__turbopack_context__.v({
  "actions": "spotlight-module__moN9Oq__actions",
  "blocker": "spotlight-module__moN9Oq__blocker",
  "body": "spotlight-module__moN9Oq__body",
  "card": "spotlight-module__moN9Oq__card",
  "cardHeader": "spotlight-module__moN9Oq__cardHeader",
  "caret": "spotlight-module__moN9Oq__caret",
  "caretBottom": "spotlight-module__moN9Oq__caretBottom",
  "caretLeft": "spotlight-module__moN9Oq__caretLeft",
  "caretRight": "spotlight-module__moN9Oq__caretRight",
  "caretTop": "spotlight-module__moN9Oq__caretTop",
  "close": "spotlight-module__moN9Oq__close",
  "dim": "spotlight-module__moN9Oq__dim",
  "dontShow": "spotlight-module__moN9Oq__dontShow",
  "fade": "spotlight-module__moN9Oq__fade",
  "ghost": "spotlight-module__moN9Oq__ghost",
  "maskSvg": "spotlight-module__moN9Oq__maskSvg",
  "mock": "spotlight-module__moN9Oq__mock",
  "mockAvatar": "spotlight-module__moN9Oq__mockAvatar",
  "mockName": "spotlight-module__moN9Oq__mockName",
  "mockRole": "spotlight-module__moN9Oq__mockRole",
  "mockRoleSecondary": "spotlight-module__moN9Oq__mockRoleSecondary",
  "navBtns": "spotlight-module__moN9Oq__navBtns",
  "note": "spotlight-module__moN9Oq__note",
  "pop": "spotlight-module__moN9Oq__pop",
  "primary": "spotlight-module__moN9Oq__primary",
  "root": "spotlight-module__moN9Oq__root",
  "secondary": "spotlight-module__moN9Oq__secondary",
  "spot": "spotlight-module__moN9Oq__spot",
  "step": "spotlight-module__moN9Oq__step",
  "title": "spotlight-module__moN9Oq__title",
});
